import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useProjectStagesList() {

    //User toast
    const toast = useToast()

    const refProjectStageListTable = ref(null)

    const tableColumns = [
        {key: 'stage', label:'項目狀態',sortable: true},
        {key: 'description', label: '描述'},
        {key: 'demo', label: 'Demo'},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalProjectStages = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refProjectStageListTable.value ? refProjectStageListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalProjectStages.value,
        }
    })

    const refetchData = () => {
        refProjectStageListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchProjectStages = (ctx, callback) => {
        store.dispatch('setting-projectstage/fetchProjectStages',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {projectstages, total} = response.data
            callback(projectstages)
            totalProjectStages.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching project stages list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchProjectStages,
        tableColumns,
        perPage,
        currentPage,
        totalProjectStages,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refProjectStageListTable,
        ability,
        refetchData
    }

}